var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('p',[_vm._v("Тестовая страница регистрации")]),_c('p',[_vm._v("для авторизации нажмите "),_c('a',{attrs:{"href":"/auth/login"}},[_vm._v("Вход")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }